import { useState } from 'react'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Dropzone } from '@/components/ui/dropzone'
import { PARSER_ACCEPTED_FILE_TYPES } from '../../../../lib/fileUpload'

interface ImportCertificateHoldersDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onImport: (file: File | File[] | null) => Promise<boolean>
  isUploading: boolean
}

export function ImportCertificateHoldersDialog({
  open,
  onOpenChange,
  onImport,
  isUploading,
}: ImportCertificateHoldersDialogProps) {
  const [file, setFile] = useState<File | null>(null)

  async function handleImport() {
    if (await onImport(file)) {
      onOpenChange(false)
      setFile(null)
    }
  }

  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        onOpenChange(isOpen)
        if (!isOpen) setFile(null)
      }}
    >
      <DialogContent size="lg">
        <DialogHeader>
          <DialogTitle>Import certificate holders</DialogTitle>
          <DialogDescription>
            Upload a spreadsheet or document listing your certificate holders. Each holder needs a name;
            emails and addresses are picked up when the file has them. A holder you already have — matched by
            name or email — is updated rather than added twice.
          </DialogDescription>
        </DialogHeader>
        <Dropzone onChange={setFile} accept={PARSER_ACCEPTED_FILE_TYPES} maxSizeMB={10} />
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isUploading}>
            Cancel
          </Button>
          <Button onClick={handleImport} disabled={!file} loading={isUploading ? 'Uploading…' : undefined}>
            Import
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
